// src/use-sigma-iframe.ts
import { useCallback, useRef, useState } from "react";

// src/wrappers.ts
import {
  workbookLoadedListener,
  workbookErrorListener,
  workbookDataLoadedListener,
  workbookVariableChangeListener,
  workbookTableCellSelectListener,
  workbookPublishedListener,
  workbookFullScreenListener,
  workbookPageHeightListener,
  workbookChartValueSelectListener,
  workbookSelectedNodeListener,
  workbookPivotTableCellSelectListener,
  workbookBookmarkCreateListener,
  workbookCurrentVariablesListener,
  workbookChartErrorListener,
  workbookExploreKeyOnChangeListener,
  workbookBookmarkOnChangeListener,
  urlOnChangeListener,
  workbookIdOnChangeListener,
  actionOutboundListener
} from "@sigmacomputing/embed-sdk";
import { useEffect } from "react";
function useWorkbookLoaded(iframeRef, onLoaded) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookLoadedListener(event, iframeRef.current, onLoaded);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onLoaded]);
}
function useWorkbookError(iframeRef, onError) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookErrorListener(event, iframeRef.current, onError);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onError]);
}
function useWorkbookDataLoaded(iframeRef, onDataLoaded) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookDataLoadedListener(event, iframeRef.current, onDataLoaded);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onDataLoaded]);
}
function useVariableChange(iframeRef, onVariableChange) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookVariableChangeListener(
        event,
        iframeRef.current,
        onVariableChange
      );
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onVariableChange]);
}
function useTableCellSelect(iframeRef, onTableCellSelect) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookTableCellSelectListener(
        event,
        iframeRef.current,
        onTableCellSelect
      );
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onTableCellSelect]);
}
function useWorkbookPublished(iframeRef, onWorkbookPublished) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookPublishedListener(event, iframeRef.current, onWorkbookPublished);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onWorkbookPublished]);
}
function useWorkbookFullScreen(iframeRef, onFullScreen) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookFullScreenListener(event, iframeRef.current, onFullScreen);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onFullScreen]);
}
function useWorkbookPageHeight(iframeRef, onPageHeight) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookPageHeightListener(event, iframeRef.current, onPageHeight);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onPageHeight]);
}
function useWorkbookSelectedNode(iframeRef, onPageSelectedNode) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookSelectedNodeListener(
        event,
        iframeRef.current,
        onPageSelectedNode
      );
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onPageSelectedNode]);
}
function useWorkbookPivotTableCellSelect(iframeRef, onPivotTableCellSelect) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookPivotTableCellSelectListener(
        event,
        iframeRef.current,
        onPivotTableCellSelect
      );
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onPivotTableCellSelect]);
}
function useWorkbookChartValueSelect(iframeRef, onChartValueSelect) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookChartValueSelectListener(
        event,
        iframeRef.current,
        onChartValueSelect
      );
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onChartValueSelect]);
}
function useWorkbookCurrentVariables(iframeRef, onCurrentVariables) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookCurrentVariablesListener(
        event,
        iframeRef.current,
        onCurrentVariables
      );
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onCurrentVariables]);
}
function useWorkbookBookmarkOnCreate(iframeRef, onBookmarkCreate) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookBookmarkCreateListener(
        event,
        iframeRef.current,
        onBookmarkCreate
      );
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onBookmarkCreate]);
}
function useWorkbookChartError(iframeRef, onChartError) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookChartErrorListener(event, iframeRef.current, onChartError);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onChartError]);
}
function useWorkbookExploreKeyOnChange(iframeRef, onExploreKeyChange) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookExploreKeyOnChangeListener(
        event,
        iframeRef.current,
        onExploreKeyChange
      );
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onExploreKeyChange]);
}
function useWorkbookBookmarkOnChange(iframeRef, onBookmarkChange) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookBookmarkOnChangeListener(
        event,
        iframeRef.current,
        onBookmarkChange
      );
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onBookmarkChange]);
}
function useUrlOnChange(iframeRef, onUrlChange) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      urlOnChangeListener(event, iframeRef.current, onUrlChange);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onUrlChange]);
}
function useWorkbookIdOnChange(iframeRef, onIdChange) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookIdOnChangeListener(event, iframeRef.current, onIdChange);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onIdChange]);
}
function useActionOutbound(iframeRef, onActionOutbound) {
  useEffect(() => {
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      actionOutboundListener(event, iframeRef.current, onActionOutbound);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [iframeRef, onActionOutbound]);
}

// src/use-sigma-iframe.ts
function useSigmaIframe() {
  const iframeRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [variables, setVariables] = useState(void 0);
  const [error, setError] = useState(null);
  const loadingCallback = useCallback((event) => {
    setLoading(false);
    setVariables(event.workbook.variables);
  }, []);
  const errorCallback = useCallback((event) => {
    setError(event);
    setLoading(false);
  }, []);
  useWorkbookLoaded(iframeRef, loadingCallback);
  useWorkbookError(iframeRef, errorCallback);
  return { iframeRef, loading, error, variables };
}

// src/use-page-height.ts
import { useState as useState2 } from "react";
function usePageHeight(iframeRef) {
  const [height, setHeight] = useState2(void 0);
  useWorkbookPageHeight(iframeRef, (event) => {
    if (!iframeRef.current) return;
    setHeight(event.pageHeight);
  });
  return height;
}

// src/use-workbook-variables.ts
import { useCallback as useCallback2, useEffect as useEffect2, useState as useState3 } from "react";
import {
  workbookVariablesList,
  workbookCurrentVariablesListener as workbookCurrentVariablesListener2,
  workbookVariablesUpdate
} from "@sigmacomputing/embed-sdk";
var useWorkbookVariables = (iframeRef) => {
  const [state, setState] = useState3();
  const getVariables = useCallback2(() => {
    if (!iframeRef.current) {
      throw new Error("iframe is not available");
    }
    workbookVariablesList(iframeRef.current);
    const promise = new Promise((resolve) => {
      setState({ state: "pending", callback: resolve });
    });
    return promise;
  }, [iframeRef]);
  const setVariables = useCallback2(
    (variables) => {
      if (!iframeRef.current) {
        throw new Error("iframe is not available");
      }
      workbookVariablesUpdate(iframeRef.current, variables);
    },
    [iframeRef]
  );
  useEffect2(() => {
    if (!iframeRef.current) return;
    const listener = (event) => {
      if (!iframeRef.current) {
        return;
      }
      workbookCurrentVariablesListener2(event, iframeRef.current, (event2) => {
        if (state?.state === "pending") {
          setState({ state: "success", variables: event2.variables });
          state.callback(event2.variables);
        }
      });
    };
    window.addEventListener("message", listener);
    return () => {
      window.removeEventListener("message", listener);
    };
  }, [iframeRef, state]);
  return {
    getVariables,
    setVariables
  };
};

// src/mutations.ts
import {
  workbookVariablesList as workbookVariablesList2,
  workbookVariablesUpdate as workbookVariablesUpdate2,
  workbookBookmarkCreate,
  workbookBookmarkUpdate,
  workbookFullscreenUpdate,
  workbookSelectedNodeIdUpdate,
  workbookSharingLinkUpdate
} from "@sigmacomputing/embed-sdk";
import { DO_NOT_USE_IN_PRODUCTION_overrideMutationUrl } from "@sigmacomputing/embed-sdk";
function getWorkbookVariables(iframeRef) {
  if (!iframeRef.current) {
    throw new Error("iframe is not available");
  }
  workbookVariablesList2(iframeRef.current);
}
function updateWorkbookVariables(iframeRef, variables) {
  if (!iframeRef.current) {
    throw new Error("iframe is not available");
  }
  workbookVariablesUpdate2(iframeRef.current, variables);
}
function createWorkbookBookmark(iframeRef, bookmark) {
  if (!iframeRef.current) {
    throw new Error("iframe is not available");
  }
  workbookBookmarkCreate(iframeRef.current, bookmark);
}
function updateWorkbookBookmark(iframeRef) {
  if (!iframeRef.current) {
    throw new Error("iframe is not available");
  }
  workbookBookmarkUpdate(iframeRef.current);
}
function updateWorkbookFullscreen(iframeRef, nodeId) {
  if (!iframeRef.current) {
    throw new Error("iframe is not available");
  }
  workbookFullscreenUpdate(iframeRef.current, nodeId);
}
function updateWorkbookSelectedNodeId(iframeRef, nodeId, nodeType) {
  if (!iframeRef.current) {
    throw new Error("iframe is not available");
  }
  workbookSelectedNodeIdUpdate(iframeRef.current, nodeId, nodeType);
}
function updateWorkbookSharingLink(iframeRef, sharingLink, sharingExplorationLink) {
  if (!iframeRef.current) {
    throw new Error("iframe is not available");
  }
  workbookSharingLinkUpdate(
    iframeRef.current,
    sharingLink,
    sharingExplorationLink
  );
}
export {
  DO_NOT_USE_IN_PRODUCTION_overrideMutationUrl,
  createWorkbookBookmark,
  getWorkbookVariables,
  updateWorkbookBookmark,
  updateWorkbookFullscreen,
  updateWorkbookSelectedNodeId,
  updateWorkbookSharingLink,
  updateWorkbookVariables,
  useActionOutbound,
  usePageHeight,
  useSigmaIframe,
  useTableCellSelect,
  useUrlOnChange,
  useVariableChange,
  useWorkbookBookmarkOnChange,
  useWorkbookBookmarkOnCreate,
  useWorkbookChartError,
  useWorkbookChartValueSelect,
  useWorkbookCurrentVariables,
  useWorkbookDataLoaded,
  useWorkbookError,
  useWorkbookExploreKeyOnChange,
  useWorkbookFullScreen,
  useWorkbookIdOnChange,
  useWorkbookLoaded,
  useWorkbookPageHeight,
  useWorkbookPivotTableCellSelect,
  useWorkbookPublished,
  useWorkbookSelectedNode,
  useWorkbookVariables
};
